$.fn.sameHeightGrid = function(span_child = 1) {
  let self = this

  self.initHeight = function() {
    var new_height = self.find('.grid__item:nth-child(' + span_child + ')').width() * .5809129;
    if (new_height > 0) {
      self.css('--image-height', new_height + 'px');
    }
  }
  self.initHeight();

  return function() {
    $(window).on('resize orientationchange load', self.initHeight);
    return self
  }()
};
